import { gql } from '@apollo/client';

export const GET_PEOPLE = gql`
query Users($search: String, $tagIds: [Int!], $missingConsent: Boolean) {
  users(search: $search, tagIds: $tagIds, missingConsent: $missingConsent) {
    photoUrl
    identifier
    name
    id
    preferredName
    scriptName
    hasNewRegistration
    # Null outside a supporter organisation, and for anyone the viewer cannot already see.
    # Answers "has this person actually taken the app up?" — see the server resolver for why it
    # is last *seen* rather than last login.
    lastSeenAt
    tags {
        id
        name
    }
  }
}`;
